module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page iii. ",
      "epub:type": "pagebreak",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Rust Belt Reporter")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("A Memoir")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("John Gallagher")]), _vm._v(" "), _c('p', {
    staticClass: "bkau1"
  }, [_vm._v("Foreword by Stephen Henderson")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('img', {
    attrs: {
      "alt": "Wayne State University Press logo",
      "height": "50",
      "src": "images/wsu-logo.jpg",
      "width": "50"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "piii"
    }
  }), _vm._v("Wayne State University Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("Detroit")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53897f3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-gallagher-0005.vue
// module id = 66
// module chunks = 0